import { GroupMarketingPreferenceFormField } from '../../models/group-marketing-preference/group-marketing-preference-form-field.enum';
import { GroupMarketingPreferenceFormValue } from '../../models/group-marketing-preference/group-marketing-preference-form-value.type';

export const mockGroupMarketingPreferenceFormValue: GroupMarketingPreferenceFormValue =
  {
    [GroupMarketingPreferenceFormField.Email]: true,
    [GroupMarketingPreferenceFormField.Post]: true,
    [GroupMarketingPreferenceFormField.Telephone]: true,
  };
